import React, { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Funzione per ottenere un cookie
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  // Funzione per impostare un cookie
  const setCookie = (name, value, days = 365) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
    console.log(`Cookie impostato: ${name}=${value}`);
  };

  useEffect(() => {
    // Controlla se esiste già il cookie 'consent_given'
    const consentGiven = getCookie('consent_given');
    console.log('consent_given cookie:', consentGiven);
    
    // Se NON esiste il cookie, mostra il banner dopo un breve delay
    if (!consentGiven) {
      setTimeout(() => {
        setIsVisible(true);
        console.log('Banner mostrato - nessun consenso trovato');
      }, 1000);
    } else {
      console.log('Banner nascosto - consenso già dato');
    }
  }, []);

  const handleAccept = () => {
    // Crea cookie 'consent_given' con valore 'true'
    setCookie('consent_given', 'true', 365);
    console.log('ACCETTA - Cookie consent_given=true salvato');
    // Nascondi il banner
    setIsVisible(false);
  };

  const handleReject = () => {
    // Crea cookie 'consent_given' con valore 'true' (indica che la scelta è stata fatta)
    setCookie('consent_given', 'true', 365);
    console.log('RIFIUTA - Cookie consent_given=true salvato');
    // Nascondi il banner
    setIsVisible(false);
  };

  // Non renderizzare nulla se il banner non è visibile (display: none)
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{
        animation: 'slideUp 0.5s ease-out forwards',
        pointerEvents: 'auto'
      }}
    >
      <div className="bg-slate-900 text-white shadow-2xl border-t-4 border-green-600">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            {/* Icona e Testo */}
            <div className="flex items-start gap-4 flex-1" style={{ pointerEvents: 'auto' }}>
              <div className="bg-green-600 p-2 rounded-lg flex-shrink-0">
                <Cookie size={24} />
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-2">Utilizzo dei Cookie 🍪</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Utilizziamo cookie tecnici e di terze parti per migliorare la tua esperienza di navigazione. 
                  Continuando a navigare, accetti l'uso dei cookie. Per maggiori informazioni consulta la nostra{' '}
                  <a 
                    href="/privacy-policy" 
                    className="text-green-400 hover:text-green-300 underline font-medium cursor-pointer"
                    target="_self"
                  >
                    Privacy Policy
                  </a>
                  {' '}e{' '}
                  <a 
                    href="/privacy-policy" 
                    className="text-green-400 hover:text-green-300 underline font-medium cursor-pointer"
                    target="_self"
                  >
                    Cookie Policy
                  </a>
                  .
                </p>
              </div>
            </div>

            {/* Pulsanti - GDPR compliant */}
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
              <button
                onClick={handleReject}
                className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-all font-semibold text-sm shadow-lg hover:shadow-xl active:scale-95"
                aria-label="Rifiuta cookie"
              >
                RIFIUTA
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all font-semibold text-sm shadow-lg hover:shadow-xl active:scale-95"
                aria-label="Accetta cookie"
              >
                ACCETTA
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;

